import { graphql } from "../services/wp.api.service";
import { loader } from "graphql.macro";

import { sanitizeUri } from "../helpers/cacheHelpers";

const query = loader("../queries/page.gql");

const wpPageQuery = (useQuery, uri, options) => {
	const saniUri = sanitizeUri(uri);
	return useQuery(
		["page", saniUri],
		() => graphql({
			query,
			variables: {
				uri: saniUri
			}
		}, true, { cacheId: `page_${saniUri}` }).
			then(({ data }) => {
				if (data.errors) {
					throw new Error(data.errors[0].message);
				}
				return data.data.pageBy;
			}),
		{
			staleTime: 10 * 60 * 1000,
			...options
		}
	);
};

export default wpPageQuery;
